// extracted by mini-css-extract-plugin
export var indeterminate = "_4z-5";
export var md = "_4z-4";
export var semantic = "_4z-6";
export var sm = "_4z-3";
export var text = "_4z-7";
export var toggleInput = "_4z-0";
export var toggleSwitch = "_4z-1";
export var xs = "_4z-2";